var React = require('react');

function Archive (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("rect",{"x":"1.6","y":"3.3","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"12.8","height":"11.2","key":0}),React.createElement("rect",{"x":"0.8","y":"1.5","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"14.4","height":"1.8","key":1}),React.createElement("rect",{"x":"4","y":"5.3","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","width":"8","height":"6","key":2})]));
}

Archive.displayName = "Archive";

Archive.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Archive;

Archive.default = Archive;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/archive.svg
// module id = ../icon/src/icons/archive.svg
// module chunks = 0